import type { FaireProductEntity } from "../../entity_types/product";

export const p_ytbke6drqz: FaireProductEntity = {
  token: "p_ytbke6drqz",
  type: "product",
  name: "Being Jade Hoop Earrings",
  brandToken: "b_1dzbmjz3lp",
  brandName: "Art by any Means Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/b65c420efb76d52189a530c3e4d2f6b44a60aeb6a02f0fbecaf6b921b7bb0189.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12e793e513057270a22d803f6a05b3fbd07502add81f789a3bab4ace30ca7f9e.jpeg",
    "https://cdn.faire.com/fastly/4799097261c583de140d2297a7c2d4e69d03bf1bfcca45e2b5fe8abfc3226758.jpeg",
  ],
  priceDollars: 51.5,
  description:
    '\n * New jade drop, green kyanite and fancy jasper faceted gemstones \n * Handmade hammered brass channel hoop \n * 14k gold-filled wire \n * 14k gold-filled earring hooks \n * 3/4" W x 1 1/2" L \nOur gemstone earrings invite you into the luxury of the present moment.\n\nPair with our Being Labradorite Necklace 84225N\n',
  tags: [],
  msrpDollars: 103,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:07.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
